import { defineStore } from "pinia";
import { IAppUserInfo } from "@/types/app-user";

interface UserInfoStore {
  userInfo: IAppUserInfo;
  statusBarHeight: number;
}

export const useUserInfoStore = defineStore("user-info", {
  state: (): UserInfoStore => ({
    userInfo: {} as IAppUserInfo,
    statusBarHeight: 0
  }),
  getters: {
    getUserInfo: state => state.userInfo
  },
  actions: {
    setUser(data: IAppUserInfo) {
      this.userInfo = data;
    },
    setStatusBarHeight(height: number) {
      this.statusBarHeight = height;
    }
  }
});
